<template>
  <div class="language">
    <p
      v-for="(lang, i) in langs"
      :key="`Lang${i}`"
      :value="lang"
      v-on:click="$i18n.locale = lang"
    >
      <label
        :class="{ 'a' : $i18n.locale !== lang }"
      >
        {{ contentLangs[i] }}
      </label>
    </p>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      langs: ['ua', 'en'],
      contentLangs: ['укр', 'eng'],
    }
  }
};
</script>
